<div *ngIf="breadcrumbs && breadcrumbs.length" class="breadcrumbs-wrap">
  <div class="breadcrumbs-container">
    <div
      *ngFor="
        let breadcrumb of breadcrumbs;
        let index = index;
        let last = last;
        trackBy: trackByValue
      "
      [class.active]="breadcrumb.active"
      (click)="!breadcrumb.active ? navigate(breadcrumb.url) : null"
      class="breadcrumb-item"
    >
      <div class="title">
        <rt-truncate>{{ breadcrumb.title }}</rt-truncate>
      </div>
      <rt-icon *ngIf="!last" name="arrow-drop-down"></rt-icon>
    </div>
  </div>
</div>
